import { Host, h } from '@stencil/core';
export class AibaSelfieContent {
  constructor() {
    this.handleCheckbox = async (event) => {
      var _a;
      this.checked = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.checked;
      this.handlers && this.handlers.handleCheckBox && this.handlers.handleCheckBox(this.checked, event);
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.checked = undefined;
  }
  componentWillLoad() {
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    else {
      this.data = this.data;
    }
    this.contentData = this.data;
  }
  render() {
    var _a, _b, _c;
    return (h(Host, null, ((_a = this.contentData) === null || _a === void 0 ? void 0 : _a.styles) && h("style", null, (_b = this.contentData) === null || _b === void 0 ? void 0 : _b.styles), this.contentData &&
      ((_c = this.contentData) === null || _c === void 0 ? void 0 : _c.elements.map(element => {
        var _a, _b, _c, _d, _e;
        if (element.name === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element.name === 'buttonGroup') {
          return (h("div", { class: "buttonGroup" }, (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements.map(item => (h("div", { class: item.classes ? item.classes : item.data._id === 'previous' ? '' : '' }, item.data._id === 'previous' && h("aiba-button", Object.assign({ handleClick: (e) => this.handlers && this.handlers.clickPreviousScreenHandler(e) }, item['data'])), item.data._id === 'next' && h("aiba-button", Object.assign({ handleClick: (e) => this.handlers && this.handlers.clickSelfieScreenHandler(e) }, item['data'])))))));
        }
        if (element.name === 'aiba-link') {
          return h("aiba-link", Object.assign({ clickEvent: (event) => this.handlers && this.handlers.nextAssesmentHandler(event) }, element['data']));
        }
        if (element.name === 'ordered-list') {
          return (h("ol", { class: "pointers" }, element.data.elements.map(elem => {
            return h("li", { innerHTML: elem.text });
          })));
        }
        if (element.name === 'aiba-icon') {
          return h("aiba-icon", Object.assign({}, element['data']));
        }
        if (element.name === 'checkbox') {
          return (h("div", { class: "consent__checkbox" }, h("input", { type: "checkbox", checked: this.checked, onChange: this.handleCheckbox, "aria-label": "checkbox", name: "checkbox", id: "checkbox", class: `checkbox ${this.checked ? 'checked' : ''}` }), h("p", { class: "labelcontainer" }, ((_b = element === null || element === void 0 ? void 0 : element.checkBoxData) === null || _b === void 0 ? void 0 : _b.data) &&
            ((_e = (_d = (_c = element === null || element === void 0 ? void 0 : element.checkBoxData) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.elements) === null || _e === void 0 ? void 0 : _e.map((element) => {
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label')
                return h("aiba-label", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
            })))));
        }
      }))));
  }
  static get is() { return "aiba-selfie-content"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-content.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-content.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "checked": {}
    };
  }
}
//# sourceMappingURL=aiba-selfie-content.js.map
